import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:5000/api';

/**
 * Fetch reservations for a business
 * @param {string} businessType - 'Shop', 'Restaurant', or 'Task'
 * @param {string} businessId - Business MongoDB ID
 * @param {string} token - Partner JWT Auth Token
 */
export const fetchReservations = async (businessType, businessId, token) => {
  if (!businessId || !businessType) return { active: [], inactive: [], data: [] };
  
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const response = await axios.get(
    `${BASE_URL}/reservation/business/${businessId}/${businessType}`,
    { headers }
  );
  return response.data;
};

/**
 * Update status of a reservation
 * @param {string} reservationId - Reservation ObjectId
 * @param {string} status - New status ('Confirmed', 'Cancelled', etc.)
 * @param {string} token - Partner JWT Auth Token
 */
export const updateReservationStatus = async (reservationId, status, token) => {
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const response = await axios.put(
    `${BASE_URL}/reservation/${reservationId}`,
    { status },
    { headers }
  );
  return response.data;
};
